/* Base Urls */
export const BASE_URL = window?.account?.API_HOST + "/api";

/* Auth endpoints */
export const LOGIN_ENDPOINT = "/token/";
export const LOGOUT_ENDPOINT = "/auth/";

/* User endpoints */
export const USER_ENDPOINT = "/user/";

/* Application endpoints */
export const APPLICATION_ENDPOINT = "/application/";

/* Workspace */
export const WORKSPACE_ENDPOINT = "/workspace/";

/* Subscription */
export const SUBSCRIPTION_ENDPOINT = "/subscription/";

/* Membership */
export const MEMBERSHIP_ENDPOINT = "/membership/";

/* Invitation */
export const INVITATION_ENDPOINT = "/invitation/";
